import loadable from '@loadable/component';
export const manifest = {
  MainBannerV3: {
    device: {
      desktop: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "MainBannerV3Desktop";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "MainBannerV3Desktop" */
          './desktop'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./desktop");
            }

            return eval('require.resolve')("./desktop");
          }

        }, {
          resolveComponent: m => m.MainBannerDesktop
        })
      },
      mobile: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "MainBannerV3Mobile";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "MainBannerV3Mobile" */
          './mobile'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./mobile");
            }

            return eval('require.resolve')("./mobile");
          }

        }, {
          resolveComponent: m => m.MainBannerMobile
        })
      }
    }
  },
  'MainBannerV3.Benefits': {
    device: {
      mobile: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "MainBannerV3BenefitsMobile";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "MainBannerV3BenefitsMobile" */
          './benefits'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./benefits");
            }

            return eval('require.resolve')("./benefits");
          }

        }, {
          resolveComponent: m => m.Benefits
        })
      }
    }
  },
  'MainBannerV3.ThemeProvider': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "MainBannerV3ThemeProvider";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "MainBannerV3ThemeProvider" */
          './theme-provider'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./theme-provider");
            }

            return eval('require.resolve')("./theme-provider");
          }

        }, {
          resolveComponent: m => m.ThemeProvider
        })
      }
    }
  },
  'MainBannerV3.SubMenu': {
    device: {
      common: {
        component: loadable({
          resolved: {},

          chunkName() {
            return "MainBannerV3SubMenu";
          },

          isReady(props) {
            const key = this.resolve(props);

            if (this.resolved[key] !== true) {
              return false;
            }

            if (typeof __webpack_modules__ !== 'undefined') {
              return !!__webpack_modules__[key];
            }

            return false;
          },

          importAsync: () => import(
          /* webpackChunkName: "MainBannerV3SubMenu" */
          './sub-menu'),

          requireAsync(props) {
            const key = this.resolve(props);
            this.resolved[key] = false;
            return this.importAsync(props).then(resolved => {
              this.resolved[key] = true;
              return resolved;
            });
          },

          requireSync(props) {
            const id = this.resolve(props);

            if (typeof __webpack_require__ !== 'undefined') {
              return __webpack_require__(id);
            }

            return eval('module.require')(id);
          },

          resolve() {
            if (require.resolveWeak) {
              return require.resolveWeak("./sub-menu");
            }

            return eval('require.resolve')("./sub-menu");
          }

        }, {
          resolveComponent: m => m.SubMenu
        })
      }
    }
  }
};